var unit = 25;
var HelperService = /** @class */ (function () {
    function HelperService() {
    }
    HelperService.getColumnWidth = function (count) {
        return count * unit;
    };
    /**
     * 获取操作列宽度
     * @param buttonCount
     */
    HelperService.getOperateWidth = function (buttonCount) {
        var baseSize = 5;
        return buttonCount <= 2 ? baseSize * unit : (8 + buttonCount) * unit;
    };
    return HelperService;
}());
export { HelperService };
